
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thanksForParticipation",
      function () {
        return require("private-next-pages/thanksForParticipation.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/thanksForParticipation"])
      });
    }
  